"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareAltiumChannelNames = void 0;
const tokenizeAltiumChannelName = (name) => name.match(/\d+|[^\d]+/g) ?? [];
const compareAltiumChannelNames = (aName, bName) => {
    const aTokens = tokenizeAltiumChannelName(aName.toLowerCase());
    const bTokens = tokenizeAltiumChannelName(bName.toLowerCase());
    const sharedTokenCount = Math.min(aTokens.length, bTokens.length);
    for (let index = 0; index < sharedTokenCount; index++) {
        const aToken = aTokens[index];
        const bToken = bTokens[index];
        const aIsNumeric = /^\d+$/.test(aToken);
        const bIsNumeric = /^\d+$/.test(bToken);
        if (aIsNumeric && bIsNumeric) {
            const numericOrder = Number(aToken) - Number(bToken);
            if (numericOrder !== 0) {
                return numericOrder;
            }
        }
        else if (aIsNumeric !== bIsNumeric) {
            return aIsNumeric ? -1 : 1;
        }
        else if (aToken !== bToken) {
            return aToken < bToken ? -1 : 1;
        }
    }
    return aTokens.length - bTokens.length;
};
exports.compareAltiumChannelNames = compareAltiumChannelNames;
//# sourceMappingURL=AltiumChannelNameOrder.js.map